/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import { getShouldUseModernViewer } from "selectors/appSelectors";
import * as constants from "constants/constants";
import HUDViewCss from "components/hud/HUDView.css";
import ModernViewerRotateIcon from "dc-icons/viewer2021/SDC_RotateCW_18_N.svg";
import ClassicViewerRotateIcon from "dc-icons/pdf_remix/s_rotatecw_w_18.svg";
import { rotatePageHandler } from "services/NavigationBarService";
import { withKeyboardShortcutLabel } from "components/hocs/withKeyboardShortcutLabel";
import ButtonWrapper from "dc-preview-utils/src/components/Button/ButtonWrapper";

const mapStoreToProps = (stores, ownProps) => {
  const useModernViewer = getShouldUseModernViewer(stores);
  const props = {
    ...ownProps,
    clickHandler: () => {
      rotatePageHandler(90);
    },
    icon: useModernViewer ? ModernViewerRotateIcon : ClassicViewerRotateIcon,
    tooltipPlacement: useModernViewer ? constants.TOOLTIP_LEFT_PLACEMENT : constants.TOOLTIP_TOP_PLACEMENT,
    tooltipDelay: constants.TOOLTIP_DELAY,
    ariaLabel: useModernViewer ? "modernviewer.arialabel.rotateView" : "arialabel.rotateView",
    tooltipString: useModernViewer ? "modernviewer.tooltip.rotateView" : "tooltip.rotateView",
    className: useModernViewer ? HUDViewCss.RotateButtonInModernViewer : HUDViewCss.RotateButton
  };
  return props;
};

const RotateViewButtonContainer = inject(mapStoreToProps)(
  withKeyboardShortcutLabel(constants.KEYBOARD_SHORTCUTS.ROTATE, ButtonWrapper)
);

export { RotateViewButtonContainer };
